module.exports = __webpack_public_path__ + "img/3.908f233c.jpg";